// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  z-index: 1000;
}

/* Container */
.add-category-container {
  max-width: 400px;
  margin: 0;
  padding: 30px;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  text-align: center;
  position: relative;
}

/* Heading */
.add-category-container h2 {
  margin-bottom: 20px;
  color: #333;
}

/* Text Input */
.add-category-container input[type="text"] {
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 15px;
  box-sizing: border-box;
  outline: none;
  transition: all 0.2s ease-in-out;
}

.add-category-container input[type="text"]::placeholder {
  color: #aaa;
}

.add-category-container input[type="text"]:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 6px rgba(59, 130, 246, 0.3);
  background-color: #fff;
}

/* Image Upload Box */
.image-upload-box {
  position: relative;
  width: 100%;
  height: 150px;
  border: 2px dashed #aaa;
  border-radius: 10px;
  margin-bottom: 20px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.image-upload-box span {
  color: #888;
  font-size: 14px;
}

.image-upload-box input[type="file"] {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Buttons */
.add-category-container button,
.add-btn {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.add-category-container button {
  color: #fff;
  background: linear-gradient(90deg, #4caf50, #45a049);
}

.add-category-container button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  border: none;
  background: transparent;
  color: #94a3b8;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  padding: 6px;
  line-height: 1;
}

.close-btn:hover {
  color: #2563eb;
  transform: rotate(90deg);
}

/* Header Bar (Search + Add Button) */
.header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

/* Search Bar */
.search-bar {
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid #0f212e;
  font-size: 0.95rem;
  width: 250px;
  background-color: #0f212e;
  color: white;
  outline: none;
  transition: all 0.2s ease-in-out;
}

.search-bar:focus {
  /* border-color: #3b82f6; */
  box-shadow: 0 0 6px rgba(59, 130, 246, 0.4);
  /* background-color: #fff; */
}

/* Add Button in Header */
.add-btn {
  background-color: #3b82f6;
  color: #fff;
  font-weight: 500;
}

.add-btn:hover {
  background-color: #2563eb;
  transform: scale(1.05);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Banner/AddBanner/AddBanner.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,YAAY;AACZ;;EAEE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB","sourcesContent":[".banner-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(6px);\n  z-index: 1000;\n}\n\n/* Container */\n.add-category-container {\n  max-width: 400px;\n  margin: 0;\n  padding: 30px;\n  background: #fff;\n  border-radius: 15px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n  text-align: center;\n  position: relative;\n}\n\n/* Heading */\n.add-category-container h2 {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n/* Text Input */\n.add-category-container input[type=\"text\"] {\n  width: 100%;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 15px;\n  box-sizing: border-box;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n}\n\n.add-category-container input[type=\"text\"]::placeholder {\n  color: #aaa;\n}\n\n.add-category-container input[type=\"text\"]:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 6px rgba(59, 130, 246, 0.3);\n  background-color: #fff;\n}\n\n/* Image Upload Box */\n.image-upload-box {\n  position: relative;\n  width: 100%;\n  height: 150px;\n  border: 2px dashed #aaa;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.image-upload-box span {\n  color: #888;\n  font-size: 14px;\n}\n\n.image-upload-box input[type=\"file\"] {\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.preview-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n/* Buttons */\n.add-category-container button,\n.add-btn {\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  border-radius: 12px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.add-category-container button {\n  color: #fff;\n  background: linear-gradient(90deg, #4caf50, #45a049);\n}\n\n.add-category-container button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: none;\n  background: transparent;\n  color: #94a3b8;\n  font-size: 20px;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 6px;\n  line-height: 1;\n}\n\n.close-btn:hover {\n  color: #2563eb;\n  transform: rotate(90deg);\n}\n\n/* Header Bar (Search + Add Button) */\n.header-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n/* Search Bar */\n.search-bar {\n  padding: 8px 16px;\n  border-radius: 12px;\n  border: 1px solid #0f212e;\n  font-size: 0.95rem;\n  width: 250px;\n  background-color: #0f212e;\n  color: white;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n}\n\n.search-bar:focus {\n  /* border-color: #3b82f6; */\n  box-shadow: 0 0 6px rgba(59, 130, 246, 0.4);\n  /* background-color: #fff; */\n}\n\n/* Add Button in Header */\n.add-btn {\n  background-color: #3b82f6;\n  color: #fff;\n  font-weight: 500;\n}\n\n.add-btn:hover {\n  background-color: #2563eb;\n  transform: scale(1.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
